import script from "./ShipTo.vue?vue&type=script&setup=true&lang=js"
export * from "./ShipTo.vue?vue&type=script&setup=true&lang=js"

import "./ShipTo.vue?vue&type=style&index=0&id=1d9245c0&lang=scss"

const __exports__ = script;

export default __exports__